/** Minimal toast notifications. */
import { h, van } from "./tb.js";

const items = van.state([]); // { id, kind, text }
let seq = 0;

const DEFAULT_TIMEOUT = { error: 7000, success: 3500, info: 4000 };

function push(kind, text, timeout) {
  const id = ++seq;
  items.val = [...items.val, { id, kind, text }];
  const ms = timeout ?? DEFAULT_TIMEOUT[kind] ?? 4000;
  if(ms > 0) setTimeout(() => dismiss(id), ms);
  return id;
}

function dismiss(id) {
  items.val = items.val.filter((t) => t.id !== id);
}

export const toast = {
  error: (text, timeout) => push("error", text, timeout),
  success: (text, timeout) => push("success", text, timeout),
  info: (text, timeout) => push("info", text, timeout),
  dismiss,
};

/** The container that renders active toasts; mount once near <body>. */
export function ToastContainer() {
  return h(".toast-container", () =>
    h("div", { class: "toast-stack" },
      items.val.map((t) =>
        h("div", { class: `toast toast--${t.kind}`, role: "alert", onclick: () => dismiss(t.id) }, [
          h("span.toast__text", t.text),
          h("button.toast__close", { "aria-label": "Zavřít", onclick: () => dismiss(t.id) }, "×"),
        ]))));
}
